export const APISQUERYKEYS = {
  MINEDRUGS: "MineDrugs",
  INFINITEMINEDRUGS: "infinite-mine-drugs",
  NEWDRUGS: "NewDrugs",
  PRODUCTS: "Products",
  INFINITEPRODUCTS: "infinite-products",
  WAREHOUSEORDERS: "WarehouseOrders",
  WAREHOUSEOFFERS: "WarehouseOffers",
  WAREHOUSEOFFERDETAILS: "WarehouseOfferDetails",
  PHARMACYOFFERS: "PharmacyOffers",
  PHARMACYOFFERDETAILS: "PharmacyOfferDetails",
  PHARMACYORDERS: "WarehouseOrders",
  STAFF: "Staff",
  PROFILE: "Profile",
  ADS: "ads",
  DRUGFULLPROFILE: "drugFullProfile",
  DRUGALTERNATIVE: "DrugAlternative",
  WAREHOUSEDETAILS: "warehouseDetails",
  PROFILEWORKINGTIMES: "ProfileWorkingTimes",
  DRUGBYID: "DrugById",
  WAREHOUSECONTACTTYPES: "WarehouseContactTypes",
  WAREHOUSEORDERBYID: "WarehouseOrderById",
  WAREHOUSEPRODUCTBYID: "WarehouseProductById",
  NOTIFICATIONSSETTINGS: "notification-settings",
  MANAGEMENT: "management",
  SHAREDCART: "sharedCart",
  SHARECARTOPTIONS: "sharedCartOptions",
  POINTSOFFERDETAILS: "pointsOfferDetails"
};
